/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert text to 8-bit binary and back. Encode any message into 0s and 1s, or paste binary to decode it — UTF-8 safe.`)
};

const es_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte texto en binario de 8 bits y al revés. Codifica cualquier mensaje en 0s y 1s, o pega binario para decodificarlo — compatible con UTF-8.`)
};

const de_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandle Text in 8-Bit-Binärcode um und wieder zurück. Codiere jede Nachricht in 0 und 1 oder füge Binärcode ein, um ihn zu dekodieren — UTF-8-sicher.`)
};

const nl_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer tekst naar 8-bits binair en terug. Codeer elk bericht in 0en en 1en, of plak binair om het te decoderen — UTF-8 veilig.`)
};

const fr_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez du texte en binaire 8 bits et inversement. Codez n'importe quel message en 0 et 1, ou collez du binaire pour le décoder — compatible UTF-8.`)
};

const it_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti il testo in binario a 8 bit e torna indietro. Codifica qualsiasi messaggio in 0 e 1, oppure incolla il binario per decodificarlo — sicuro per UTF-8.`)
};

const pt_br2_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta texto para binário de 8 bits e vice-versa. Codifique qualquer mensagem em 0s e 1s, ou cole binário para decodificá-lo — seguro para UTF-8.`)
};

const pt_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta texto em binário de 8 bits e vice-versa. Codifique qualquer mensagem em 0s e 1s, ou cole binário para descodificá-lo — seguro para UTF-8.`)
};

const ja_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを 8 ビットのバイナリに変換したり戻したりできます。任意のメッセージを 0 と 1 にエンコードするか、バイナリを貼り付けてデコードしてください。UTF-8 対応です。`)
};

const zh_tb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将文本转换为8位二进制,反之亦然。将任意信息编码为0和1,或粘贴二进制进行解码 — 兼容UTF-8。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_intro", locale)
	if (locale === "en") return en_tb_intro(inputs)
	if (locale === "es") return es_tb_intro(inputs)
	if (locale === "de") return de_tb_intro(inputs)
	if (locale === "nl") return nl_tb_intro(inputs)
	if (locale === "fr") return fr_tb_intro(inputs)
	if (locale === "it") return it_tb_intro(inputs)
	if (locale === "pt-BR") return pt_br2_tb_intro(inputs)
	if (locale === "pt") return pt_tb_intro(inputs)
	if (locale === "ja") return ja_tb_intro(inputs)
	return zh_tb_intro(inputs)
};